import * as Yup from 'yup'

import { formatRawDataForSpreadSheet } from '../../../features/formatters'

// Create custom initial data with 6 rows for audience segments and geo distribution
const customInitialData = Array(6)
  .fill()
  .map(() => [undefined, undefined])

export const NAME = 'name'
export const ICON = 'icon'
export const ICON_NAME = 'icon_name'
export const FACEBOOK_BUSINESS_MANAGER_ID = 'facebook_bm_id'

export const AUDIENCE_SEGMENTS = 'audience_segments'
export const GEO_DISTRIBUTION = 'geo_distribution'
export const DIGITAL_STRENGTHS = 'digital_strengths'
export const RH_PLATFORMS = 'rh_platforms'

export const getInitialValues = rightHolderData => {
  const rightHolderName = rightHolderData?.[NAME]
  const facebookId = rightHolderData?.[FACEBOOK_BUSINESS_MANAGER_ID]
  const rhProfile = rightHolderData?.rh_profile || {}

  return {
    [NAME]: rightHolderName || '',
    // icon should always be empty string, because we don't want to show the icon of the right holder
    // also it is not possible to delete the icon of the right holder, so it is ignored to be sent in payload
    [ICON]: '',
    [ICON_NAME]: '',

    [FACEBOOK_BUSINESS_MANAGER_ID]: facebookId || '',
    // rh_profile fields
    [AUDIENCE_SEGMENTS]: rhProfile.audience_segments
      ? formatRawDataForSpreadSheet(rhProfile.audience_segments, ['name', 'size'], 6)
      : customInitialData,
    [GEO_DISTRIBUTION]: rhProfile.geo_distribution
      ? formatRawDataForSpreadSheet(
          // Convert ratio [0, 1] to percentage [0, 100]
          rhProfile.geo_distribution.map(item => ({
            country: item.country,
            ratio: item.ratio * 100 // Convert to percentage
          })),
          ['country', 'ratio'],
          6
        )
      : customInitialData,
    [DIGITAL_STRENGTHS]: rhProfile.digital_strengths || '',
    [RH_PLATFORMS]: rhProfile.rh_platforms
      ? rhProfile.rh_platforms.map(platform => ({ value: platform, label: platform }))
      : []
  }
}

export const validationSchema = Yup.object().shape({
  [NAME]: Yup.string().required('Please enter name').max(255, 'Name should have maximum 255 characters'),
  [GEO_DISTRIBUTION]: Yup.array()
    .test({
      message: 'Percentage values must be between 0 and 100',
      test: rows =>
        !rows.find(row => {
          // Check if the percentage value exists and is not within the valid range
          const percentageValue = row[1] && row[1].value !== undefined ? parseFloat(row[1].value) : null
          return percentageValue !== null && (isNaN(percentageValue) || percentageValue < 0 || percentageValue > 100)
        })
    })
    .test({
      message: 'Sum of percentages cannot exceed 100',
      test: rows => {
        // Calculate sum of all valid percentage values
        const sum = rows.reduce((total, row) => {
          const percentageValue = row[1] && row[1].value !== undefined ? parseFloat(row[1].value) : 0
          return total + (isNaN(percentageValue) ? 0 : percentageValue)
        }, 0)
        return sum <= 100
      }
    })
})
